/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { MyNetworkContext } from 'v4/components/network/context';
import { getUserFullName } from 'v4/lib/commons';
export const RemoveHandshakeRequestModal = forwardRef(({ ...props }, ref) => {
  const {
    selectedUser,
    removeHandshakeRequestDisc,
    rejectInvitation,
    rejectInvitationLoading,
    
  } = useContext(MyNetworkContext);

  const onRejectInvitation = () => {
    rejectInvitation?.(selectedUser);
  };

  // console.log(selectedUser);

  return (
    <Modal size="xl" {...(removeHandshakeRequestDisc ?? {})}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Remove request
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          <Stack spacing={4}>
            <Text>
              Are you sure you want to remove this connection request?
            </Text>
            <Text>
              {selectedUser?.user_info?.first_name} won&apos;t get notified that you did
              this, but you will stop seeing it in Pending Invitations.
            </Text>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <HStack>
            <Button
              onClick={(e) => removeHandshakeRequestDisc?.onClose?.()}
              variant="secondary"
              borderRadius="full"
            >
              Cancel
            </Button>
            <Button
              onClick={onRejectInvitation}
              isLoading={rejectInvitationLoading}
              type="submit"
              borderRadius="full"
              variant="primary"
            >
              Remove
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
});
